import axios from 'axios';
import { baseUrl, token } from '../../../services/Apis';

export const conceptosApi = `${baseUrl}/conceptos-pago`;

export const allConceptosService = async (params) => {
  const res = await axios.get(conceptosApi, {
    headers: token({}),
    params,
  });
  return res;
};

export const saveConceptosService = async (id, data) => {
  let res;
  if (id) {
    res = await axios.patch(`${conceptosApi}/${id}`, data, {
      headers: token({}),
    });
  } else {
    res = await axios.post(`${conceptosApi}`, data, {
      headers: token({}),
    });
  }
  return res;
};

export const oneConceptosService = async (id) => {
  const res = await axios.get(`${conceptosApi}/${id}`, {
    headers: token({}),
  });
  return res;
};

export const deleteConceptosService = async (id) => {
  const res = await axios.delete(`${conceptosApi}/${id}`, {
    headers: token({}),
  });
  return res;
};
